import color from "../../../../theme/color";
import { TextTag } from "../../../Tags/Text";
import { TagSizes } from "../../../Tags/utils/theme";

/**
 * 출장교체 enum
 * @notice 출장교체는 작업완료 이전까지 일자변경 가능
 */
export enum OnsiteStatus {
  /**
   * 예약신청
   */
  COMPLETED_PAYMENT = "예약신청",
  /**
   * 예약신청
   */
  PENDING = "예약신청",
  /**
   * 예약확정
   */
  APPROVED = "예약확정",
  /**
   * 작업완료
   */
  COMPLETED = "작업완료",
  /**
   * 예약취소
   */
  CANCELED = "예약취소",
}

/**
 * 출장교체 key type
 */
export type OnsiteStatusType = keyof typeof OnsiteStatus;

/**
 * 출장교체별 컬러
 */
export const onsiteStatusTypeColor: {
  [key: string]: string;
} = {
  COMPLETED_PAYMENT: color.secondary3,
  PENDING: color.secondary3,
  APPROVED: color.primary3,
  COMPLETED: color.gray2,
  CANCELED: color.red3,
};

interface OnsiteStatusTagProps {
  value: OnsiteStatusType;
  size?: TagSizes;
}

/**
 * 출장교체 태그
 * @param value
 * @returns
 */
export const OnsiteStatusTag: React.FC<OnsiteStatusTagProps> = ({
  value,
  size,
}) => {
  return (
    <>
      {OnsiteStatus[value] ? (
        <TextTag colors={onsiteStatusTypeColor[value]} size={size}>
          {OnsiteStatus[value]}
        </TextTag>
      ) : (
        "-"
      )}
    </>
  );
};
